module.exports = __webpack_public_path__ + "arrow-next@2x.png?6a0c88f986c31ad0e656f895cf203bde";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-next@2x.png
// module id = 23
// module chunks = 0